import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Grid,
  Paper,
  Avatar,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Checkbox,
  FormGroup,
  Stack,
  Collapse,
  IconButton,
  Tooltip,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import {
  ArrowBack,
  CheckCircle,
  PlayCircle,
  LocationOn,
  CurrencyRupee,
  Public,
  ToggleOn,
  ToggleOff,
  ExpandMore,
  ExpandLess,
  Info,
  Category,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import useAxios from "../useAxios";
import ModernLoder, {
  CategoryDetailsLoader,
  RegistrationIdeasLoader,
  ProductDetailLoader,
  ProductCategoriesLoader,
  ProductDetailSkeleton
} from "./ModernLoder";

// Custom styled components
const GradientButton = styled(Button)(({ theme }) => ({
  background: `linear-gradient(90deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.common.white,
  borderRadius: "8px",
  padding: "10px 20px",
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    boxShadow: `0 4px 12px ${theme.palette.primary.light}`,
  },
}));

const CompactCard = styled(Card)(({ theme }) => ({
  borderRadius: "12px",
  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
  transition: "all 0.2s ease",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
  },
}));

const StatusPill = styled(Chip)(({ theme, status }) => ({
  backgroundColor:
    status === "on" ? theme.palette.success.light : theme.palette.error.light,
  color:
    status === "on" ? theme.palette.success.dark : theme.palette.error.dark,
  fontWeight: 600,
  padding: "4px 8px",
  borderRadius: "12px",
  "& .MuiChip-label": {
    padding: "0 4px",
  },
}));
const PricingCard = styled(Card)(({ theme }) => ({
  borderRadius: "12px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
  transition: "all 0.3s ease",
  border: `1px solid ${theme.palette.divider}`,
  "&:hover": {
    transform: "translateY(-5px)",
    boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
  },
}));
// const CategorySettingsAdmin = ({onBack }) => {
//   const axiosData = useAxios();
//   const theme = useTheme();
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [cityStatus, setCityStatus] = useState({});
//   const [openCityDialog, setOpenCityDialog] = useState(false);
//   const [selectedOffCities, setSelectedOffCities] = useState([]);
//   const [expandedSections, setExpandedSections] = useState({
//     deliverables: false,
//     requirements: false,
//     materials: false,
//     pricing: false,
//   });
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

// useEffect(() => {
//     setCategories([]);
//     setLoading(true);
//     fetchCategory();
//   }, []);
//   /* Get all users list from api*/
//   const fetchCategory = async () => {
//     await axiosData
//       .get(`getAllProductCategory`)
//       .then((data) => {
//         setCategories(data.data.productCAtegory);
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.log("Error", error);
//         setLoading(false);
//       });
//   };
//   const isFullyOn = Object.values(cityStatus).every((v) => v === "on");
//   const isFullyOff = Object.values(cityStatus).every((v) => v === "off");

//   const toggleSection = (section) => {
//     setExpandedSections((prev) => ({
//       ...prev,
//       [section]: !prev[section],
//     }));
//   };

//   const handleCityToggle = async (city,category) => {
//     const newStatus = cityStatus[city] === "on" ? "off" : "on";
//     const updatedStatus = { ...cityStatus, [city]: newStatus };
//     try {
//       setLoading(true);
//       const response = await axiosData.put(`editProductDetails`, {
//         _id: category._id,
//         status: updatedStatus,
//       });
//       if (response.data) {
//         setCityStatus(updatedStatus);
//       }
//     } catch (error) {
//       console.error("City status update failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleGlobalToggle = async (category) => {
//     const newStatus = isFullyOn ? "off" : "on";
//     const updatedStatus = Object.keys(cityStatus).reduce((acc, city) => {
//       acc[city] = newStatus;
//       return acc;
//     }, {});

//     try {
//       setLoading(true);
//       const response = await axiosData.put(`editProductDetails`, {
//         _id: category._id,
//         status: updatedStatus,
//       });
//       if (response.data) {
//         setCityStatus(updatedStatus);
//       }
//     } catch (error) {
//       console.error("Global status update failed:", error);
//     } finally {
//       setLoading(false);
//     }
//   };
//   return (
//     <Container maxWidth="lg" sx={{ py: 3 }}>
//       <Grid container spacing={2}>
//         {/* Main Content Column */}
//        {categories.map((product)=> <Grid item xs={12} md={12} fullWidth>
//           {/* Product Header */}
//           <CompactCard sx={{ mb: 2 }} >
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   flexDirection: { xs: "column", sm: "row" }, // Stack on mobile, row on larger screens
//                   justifyContent: "space-between",
//                   alignItems: { xs: "flex-start", sm: "center" },
//                   gap: 2,
//                   width: "100%",
//                 }}
//               >
//                 {/* Left side - Product name and category */}
//                 <Box
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: { xs: "flex-start" },
//                   }}
//                 >
//                   <Typography
//                     variant="h4"
//                     gutterBottom
//                     color="primary"
//                     sx={{
//                       fontWeight: { xs: 800, sm: 800, md: 800 }, // Bold on sm+ screens
//                       fontSize: { xs: "1.5rem", sm: "2rem", md: "2rem" }, // Same small size for all screen
//                     }}
//                   >
//                     {product.name}
//                   </Typography>
//                 </Box>

//                 {/* Right side - Status and toggle button */}
//                 <Stack
//                   direction={{ xs: "column", sm: "row" }} // Stack vertically on mobile, row on larger screens
//                   alignItems={{ xs: "flex-start", sm: "center" }}
//                   spacing={1}
//                   sx={{
//                     width: { xs: "100%", sm: "auto" },
//                     mt: { xs: 1, sm: 0 },
//                   }}
//                 >
//                   <Tooltip
//                     title={
//                       isFullyOn
//                         ? "All cities active"
//                         : isFullyOff
//                         ? "All cities inactive"
//                         : "Partial availability"
//                     }
//                   >
//                     <Typography
//                       variant="subtitle1"
//                       color={isFullyOn ? "success.main" : "text.disabled"}
//                       sx={{
//                         display: "flex",
//                         alignItems: { xs: "flex-start", sm: "flex-start" },
//                         justifyContent: { xs: "flex-start", sm: "flex-start" },
//                       }}
//                     >
//                       <Public
//                         color={
//                           isFullyOn
//                             ? "success"
//                             : isFullyOff
//                             ? "error"
//                             : "warning"
//                         }
//                       />
//                       {isFullyOn
//                         ? "All Cities Active"
//                         : isFullyOff
//                         ? "All Cities Inactive"
//                         : "Partial Availability"}
//                     </Typography>
//                   </Tooltip>

//                   <Button
//                     variant="outlined"
//                     color={isFullyOn ? "error" : "success"}
//                     startIcon={isFullyOn ? <ToggleOff /> : <ToggleOn />}
//                     onClick={handleGlobalToggle}
//                     sx={{
//                       textTransform: "none",
//                       fontWeight: 600,
//                       borderRadius: "20px",
//                       px: 3,
//                       py: 1,
//                       width: { xs: "100%", sm: "auto" }, // Full width on mobile, auto on larger screens
//                     }}
//                   >
//                     {isFullyOn ? "Disable All" : "Enable All"}
//                   </Button>
//                 </Stack>
//               </Box>
//             </CardContent>
//           </CompactCard>

//           {/* City Status Cards */}
//           <CompactCard sx={{ mb: 2 }}>
//             <CardContent>
//               <Box
//                 sx={{
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 1,
//                 }}
//               >
//                 <Typography variant="subtitle1" fontWeight={800}>
//                   City Availability
//                 </Typography>
//                 <Typography variant="caption" color="text.secondary">
//                   {Object.values(cityStatus).filter((v) => v === "on").length}{" "}
//                   of {Object.keys(cityStatus).length} active
//                 </Typography>
//               </Box>

//               <Grid container spacing={1}>
//                 {Object.entries(cityStatus).map(([city, status], index) => (
//                   <Grid item xs={6} sm={4} key={index}>
//                     <Paper
//                       elevation={0}
//                       sx={{
//                         p: 1.5,
//                         borderRadius: "8px",
//                         border: "1px solid",
//                         borderColor:
//                           status === "on" ? "success.light" : "error.main",
//                         backgroundColor:
//                           status === "on" ? "success.50" : "background.paper",
//                       }}
//                     >
//                       <Stack
//                         direction="row"
//                         alignItems="center"
//                         justifyContent="space-between"
//                       >
//                         <Typography variant="body2" fontWeight={500}>
//                           {city.charAt(0).toUpperCase() + city.slice(1)}
//                         </Typography>
//                         <IconButton
//                           size="small"
//                           onClick={() => handleCityToggle(city)}
//                           sx={{
//                             p: 0.5,
//                             color:
//                               status === "on" ? "success.main" : "error.main",
//                           }}
//                         >
//                           {status === "on" ? (
//                             <ToggleOn fontSize="small" />
//                           ) : (
//                             <ToggleOff fontSize="small" />
//                           )}
//                         </IconButton>
//                       </Stack>
//                     </Paper>
//                   </Grid>
//                 ))}
//               </Grid>
//             </CardContent>
//           </CompactCard>
//         </Grid>)}
//       </Grid>
//     </Container>
//   );
// };
const CategorySettingsAdmin = ({ onBack }) => {
  const axiosData = useAxios();
  const theme = useTheme();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // city status per category
  const [cityStatus, setCityStatus] = useState({}); 
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setCategories([]);
    setLoading(true);
    fetchCategory();
  }, []);

  /* Get all categories list from api */
  const fetchCategory = async () => {
    try {
      const  data  = await axiosData.get(`getAllProductCategory`);
      const productCategories = data.data.productCAtegory || [];
      setCategories(data.data.productCAtegory);

      // initialize city status for each category
      const initStatus = {};
      productCategories.forEach((cat) => {
        initStatus[cat._id] = cat.status || {}; // from API
      });
      setCityStatus(initStatus);
    } catch (error) {
      console.log("Error", error);
    } finally {
      setLoading(false);
    }
  };

  const isFullyOn = (categoryId) =>
    Object.values(cityStatus[categoryId] || {}).every((v) => v === "on");
  const isFullyOff = (categoryId) =>
    Object.values(cityStatus[categoryId] || {}).every((v) => v === "off");

  const handleCityToggle = async (category, city) => {
    const currentStatus = cityStatus[category._id] || {};
    const newStatus = currentStatus[city] === "on" ? "off" : "on";
    const updatedStatus = { ...currentStatus, [city]: newStatus };

    try {
      setLoading(true);
      const response = await axiosData.put(`editProductCat`, {
        _id: category._id,
        status: updatedStatus,
      });
      if (response.data) {
        setCityStatus((prev) => ({
          ...prev,
          [category._id]: updatedStatus,
        }));
      }
    } catch (error) {
      console.error("City status update failed:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleGlobalToggle = async (category) => {
    const currentStatus = cityStatus[category._id] || {};
    const fullyOn = isFullyOn(category._id);

    const updatedStatus = Object.keys(currentStatus).reduce((acc, city) => {
      acc[city] = fullyOn ? "off" : "on";
      return acc;
    }, {});

    try {
      setLoading(true);
      const response = await axiosData.put(`editProductCat`, {
        _id: category._id,
        status: updatedStatus,
      });
      if (response.data) {
        setCityStatus((prev) => ({
          ...prev,
          [category._id]: updatedStatus,
        }));
      }
    } catch (error) {
      console.error("Global status update failed:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Grid container spacing={2}>
        {categories.map((product) => {
          const statusForCategory = cityStatus[product._id] || {};
          const fullyOn = isFullyOn(product._id);
          const fullyOff = isFullyOff(product._id);

          return (
            <Grid item xs={12} key={product._id}>
              {/* Product Header */}
              <CompactCard sx={{ mb: 2 }}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      justifyContent: "space-between",
                      alignItems: { xs: "flex-start", sm: "center" },
                      gap: 2,
                    }}
                  >
                    <Typography
                      variant="h4"
                      gutterBottom
                      color="primary"
                      sx={{
                        fontWeight: 800,
                        fontSize: { xs: "1.5rem", sm: "2rem" },
                      }}
                    >
                      {product.name}
                    </Typography>
                    <Stack
                      direction={{ xs: "column", sm: "row" }}
                      alignItems={{ xs: "flex-start", sm: "center" }}
                      spacing={1}
                    >
                      <Tooltip
                        title={
                          fullyOn
                            ? "All cities active"
                            : fullyOff
                            ? "All cities inactive"
                            : "Partial availability"
                        }
                      >
                        <Typography
                          variant="subtitle1"
                          color={fullyOn ? "success.main" : "text.disabled"}
                          sx={{ display: "flex", alignItems: "center" }}
                        >
                          <Public
                            color={
                              fullyOn
                                ? "success"
                                : fullyOff
                                ? "error"
                                : "warning"
                            }
                          />
                          {fullyOn
                            ? "All Cities Active"
                            : fullyOff
                            ? "All Cities Inactive"
                            : "Partial Availability"}
                        </Typography>
                      </Tooltip>

                      <Button
                        variant="outlined"
                        color={fullyOn ? "error" : "success"}
                        startIcon={fullyOn ? <ToggleOff /> : <ToggleOn />}
                        onClick={() => handleGlobalToggle(product)}
                        sx={{
                          textTransform: "none",
                          fontWeight: 600,
                          borderRadius: "20px",
                          px: 3,
                          py: 1,
                          width: { xs: "100%", sm: "auto" },
                        }}
                      >
                        {fullyOn ? "Disable All" : "Enable All"}
                      </Button>
                    </Stack>
                  </Box>
                </CardContent>
              </CompactCard>

              {/* City Status */}
              <CompactCard sx={{ mb: 2 }}>
                <CardContent>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                    }}
                  >
                    <Typography variant="subtitle1" fontWeight={800}>
                      City Availability
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {Object.values(statusForCategory).filter(
                        (v) => v === "on"
                      ).length}{" "}
                      of {Object.keys(statusForCategory).length} active
                    </Typography>
                  </Box>

                  <Grid container spacing={1}>
                    {Object.entries(statusForCategory).map(
                      ([city, status], index) => (
                        <Grid item xs={6} sm={4} key={index}>
                          <Paper
                            elevation={0}
                            sx={{
                              p: 1.5,
                              borderRadius: "8px",
                              border: "1px solid",
                              borderColor:
                                status === "on"
                                  ? "success.light"
                                  : "error.main",
                              backgroundColor:
                                status === "on"
                                  ? "success.50"
                                  : "background.paper",
                            }}
                          >
                            <Stack
                              direction="row"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              <Typography variant="body2" fontWeight={500}>
                                {city.charAt(0).toUpperCase() + city.slice(1)}
                              </Typography>
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleCityToggle(product, city)
                                }
                                sx={{
                                  p: 0.5,
                                  color:
                                    status === "on"
                                      ? "success.main"
                                      : "error.main",
                                }}
                              >
                                {status === "on" ? (
                                  <ToggleOn fontSize="small" />
                                ) : (
                                  <ToggleOff fontSize="small" />
                                )}
                              </IconButton>
                            </Stack>
                          </Paper>
                        </Grid>
                      )
                    )}
                  </Grid>
                </CardContent>
              </CompactCard>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
};

export default CategorySettingsAdmin;
